export const DAT_ID_INPUT_PATTERN = "[0-9]*";

export function sanitizeDatIdInput(value: string): string {
  return value.replace(/\D/g, "");
}
